import { useState } from 'react';
import { useHttpContext } from '@web-libs/core/http/infrastructure/client-side/http.context';

type FeatureName =
  | 'feature.sharedClientInstDir'
  | 'feature.customForms'
  | 'feature.proofOfSalary';

type TageaBooleanConfig = {
  name: FeatureName;
  type: 'BOOLEAN';
  value: '1' | '0';
}[];

export const useTageaConfig = () => {
  const httpClient = useHttpContext();
  const [config, setConfig] = useState<TageaBooleanConfig | null>(null);

  const loadConfig = async () => {
    const response =
      await httpClient.get<TageaBooleanConfig>('/public/v2/config');
    setConfig(response);
    return response;
  };

  const isFeatureEnabled = (featureName: FeatureName) => {
    console.log(config)
    return (
      config?.find((feature) => feature.name === featureName)?.value === '1'
    );
  };

  const isFeatureDisabled = (featureName: FeatureName) => {
    return (
      config?.find((feature) => feature.name === featureName)?.value === '0'
    );
  };

  return {
    config,
    loadConfig,
    isFeatureEnabled,
    isFeatureDisabled,
  };
};
